import { css } from 'styled-components';

export const breakpoints = {
    phone_sm: '320px',
    phone_md: '375px',
    phone_lg: '425px',
    tablet_sm: '560px',
    tablet_md: '640px',
    tablet_lg: '768px',
    laptop: '1024px',
    desktop_sm: '1200px',
    desktop: '1440px'
}

export const mediaMin = Object.keys(breakpoints).reduce(
    (accumulator, label) => {
      accumulator[label] = (...args) => css`
        @media (min-width: ${breakpoints[label]}) {
          ${css(...args)};
        }
      `;
      return accumulator;
    },
    {}
  );
